export default {"src":"/_next/static/media/ella-chat-icon.9a99115a.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};